/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { AccountDetails } from '../model/accountDetails';
import { AccountList } from '../model/accountList';
import { CreateAccount } from '../model/createAccount';
import { EditAccount } from '../model/editAccount';
import { ResetPasswordStart } from '../model/resetPasswordStart';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BackofficeAccountService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Szczegoły wybranego konta
     *  - __Path__: /backoffice/accounts/{id} - __OperationName__: Query - __OutputModelName__: AccountDetails - __Entity__: SalesMailer\\Domain\\Account - __Type__: doctrine - __OperationId__: AccountDetailsQuery - __Name__:  - __Method__: GET - __Description__:  - __Summary__: Szczegoły wybranego konta - __RouteName__: GETAccountDetailsQuery - __Hash__: 711f0f0a7172417fe34e38e090f7e48e - __Input__:  - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: details - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public accountDetailsQuery(id: string, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public accountDetailsQuery(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public accountDetailsQuery(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public accountDetailsQuery(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling accountDetailsQuery.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AccountDetails>(`${this.basePath}/api/backoffice/accounts/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista kont Handlowców
     *  - __Type__: doctrine - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\Account - __OperationId__: AccountListQuery - __OperationName__: ListQuery - __OutputModelName__: AccountListItem - __ListModelName__: AccountList - __DefaultSortOrder__:  - __Name__:  - __Path__: /backoffice/accounts - __Method__: GET - __Description__:  - __Summary__: Lista kont Handlowców - __RouteName__: GETAccountListItemListQuery - __Hash__: 505641352d9ca148ec2af1022a0c00bb - __Input__:  - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: list - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param page Numer strony (default: 1)
     * @param count Liczba wierszy na stronie (default: 25)
     * @param sortOrder Pole według którego nastąpi sortowanie
     * @param sortDirection Kierunek sortowania
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public accountListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean): Observable<AccountList>;
    public accountListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountList>>;
    public accountListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountList>>;
    public accountListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AccountList>(`${this.basePath}/api/backoffice/accounts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Utwórz nowe konto dla Handlowca, wraz z wysłaniem e-maila aktywacyjnego umożliwiającego ustawienie hasła
     *  - __InputModelName__: CreateAccount - __InputParser__: serializer - __OperationName__: CreateAccountHandler - __OperationId__: CreateAccountHandler - __Name__:  - __Path__: /backoffice/accounts - __Method__: POST - __Description__:  - __Summary__: Utwórz nowe konto dla Handlowca, wraz z wysłaniem e-maila aktywacyjnego umożliwiającego ustawienie hasła - __RouteName__: POSTAccountDetailsCreateAccountHandler - __Hash__: 9197c20c8c8d5f02f5d6d3f745ce276b - __Input__: SalesMailer\\Application\\Account\\CreateAccount - __Output__: SalesMailer\\Domain\\Account - __InputGroups__: createAccount - __OutputGroups__: details - __OutputModelName__: AccountDetails - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createAccountHandler(content?: CreateAccount, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public createAccountHandler(content?: CreateAccount, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public createAccountHandler(content?: CreateAccount, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public createAccountHandler(content?: CreateAccount, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AccountDetails>(`${this.basePath}/api/backoffice/accounts`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Usuń konto Handlowca
     *  - __InputModelName__: DeleteAccount - __Path__: /backoffice/accounts/{id} - __IsDeletableMethodName__: isDeletable - __TarEntity__:  - __EntityId__:  - __OperationName__: Handler - __OperationId__: DeleteAccountHandler - __Name__:  - __Method__: DELETE - __Description__:  - __Summary__: Usuń konto Handlowca - __RouteName__: DELETEHandler - __Hash__: 408cd27fef195f3b8ab57589ca42af2c - __Input__: SalesMailer\\Domain\\Account - __Output__:  - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteAccountHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteAccountHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteAccountHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteAccountHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteAccountHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/backoffice/accounts/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edycja konto Handlowca
     *  - __InputParser__: serializer - __UpdateMethodName__: update - __Path__: /backoffice/accounts/{id} - __InputModelName__: EditAccount - __OperationName__: EditAccountHandler - __OperationId__: EditAccountHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__: Edycja konto Handlowca - __RouteName__: PUTAccountDetailsEditAccountHandler - __Hash__: f0134e94f5864dd8050ade12661781b3 - __Input__: SalesMailer\\Application\\Account\\EditAccount - __Output__: SalesMailer\\Domain\\Account - __InputGroups__: editAccount - __OutputGroups__: details - __OutputModelName__: AccountDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editAccountHandler(id: string, content?: EditAccount, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public editAccountHandler(id: string, content?: EditAccount, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public editAccountHandler(id: string, content?: EditAccount, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public editAccountHandler(id: string, content?: EditAccount, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling editAccountHandler.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AccountDetails>(`${this.basePath}/api/backoffice/accounts/${encodeURIComponent(String(id))}`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zresetowanie hasła użytkownika przez administratora
     *  - __InputModelName__: ResetPasswordStart - __InputParser__: serializer - __OperationName__: Handler - __OperationId__: ResetPasswordStartHandler - __Name__:  - __Path__: /backoffice/accounts/{id}/password/reset - __Method__: POST - __Description__:  - __Summary__: Zresetowanie hasła użytkownika przez administratora - __RouteName__: POSTAccountDetailsHandler - __Hash__: e9c9ed97ce32757172d05f69c4b35533 - __Input__: SalesMailer\\Application\\Account\\ResetPasswordStart - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: AccountDetails - __OutputType__:  - __OutputFileType__:  
     * @param id 
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetPasswordStartHandler(id: string, content?: ResetPasswordStart, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public resetPasswordStartHandler(id: string, content?: ResetPasswordStart, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public resetPasswordStartHandler(id: string, content?: ResetPasswordStart, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public resetPasswordStartHandler(id: string, content?: ResetPasswordStart, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling resetPasswordStartHandler.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AccountDetails>(`${this.basePath}/api/backoffice/accounts/${encodeURIComponent(String(id))}/password/reset`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: block - __Path__: /backoffice/accounts/{id}/block - __InputModelName__: UpdateAccount - __OperationName__: BlockAccountHandler - __OperationId__: UpdateAccountBlockAccountHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTAccountDetailsBlockAccountHandler - __Hash__: 18ddf902eb600c3462aa5172e5396277 - __Input__: SalesMailer\\Domain\\Account - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: AccountDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAccountBlockAccountHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public updateAccountBlockAccountHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public updateAccountBlockAccountHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public updateAccountBlockAccountHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateAccountBlockAccountHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<AccountDetails>(`${this.basePath}/api/backoffice/accounts/${encodeURIComponent(String(id))}/block`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: unBlock - __Path__: /backoffice/accounts/{id}/unblock - __InputModelName__: UpdateAccount - __OperationName__: UnBlockAccountHandler - __OperationId__: UpdateAccountUnBlockAccountHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTAccountDetailsUnBlockAccountHandler - __Hash__: ce0556a6d3c0473deb33f4542c987b3e - __Input__: SalesMailer\\Domain\\Account - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: AccountDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAccountUnBlockAccountHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public updateAccountUnBlockAccountHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public updateAccountUnBlockAccountHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public updateAccountUnBlockAccountHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateAccountUnBlockAccountHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<AccountDetails>(`${this.basePath}/api/backoffice/accounts/${encodeURIComponent(String(id))}/unblock`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
